import { select, call } from 'redux-saga/effects'

export const getSurvey = state => state.survey

export function* createSurvey(api, action) {
    var survey = yield select(getSurvey)
    yield call(api.setSurvey, survey)    
}